<template>
  <v-dialog
    :value="value"
    max-width="440"
    content-class="rmr-confirm-dialog"
    @input="$emit('input', $event)"
  >
    <v-card class="rmr-confirm-card">
      <div class="rmr-confirm-card__header">
        <div
          class="rmr-confirm-card__icon-box"
          :class="
            danger
              ? 'rmr-confirm-card__icon-box--danger'
              : 'rmr-confirm-card__icon-box--default'
          "
        >
          <v-icon :color="danger ? colors.danger : colors.indigo">
            {{ danger ? icons.mdiAlertCircle : icons.mdiHelpCircle }}
          </v-icon>
        </div>
        <div class="rmr-confirm-card__title">{{ title }}</div>
      </div>

      <div v-if="message || $slots.message" class="rmr-confirm-card__message">
        <slot name="message">{{ message }}</slot>
      </div>

      <div class="rmr-confirm-card__actions">
        <rmr-action-button
          :label="cancelLabel"
          variant="ghost"
          @click="onCancel"
        />
        <rmr-action-button
          :label="confirmLabel"
          :variant="danger ? 'transparent' : 'primary'"
          :color="danger ? colors.danger : null"
          @click="onConfirm"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiAlertCircle, mdiHelpCircle } from "@mdi/js";
import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import { RMR_DANGER, RMR_INDIGO } from "@/styles/tokens";

export default {
  name: "RmrConfirmDialog",
  components: {
    RmrActionButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "",
    },
    confirmLabel: {
      type: String,
      default: "Confirmer",
    },
    cancelLabel: {
      type: String,
      default: "Annuler",
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiAlertCircle,
        mdiHelpCircle,
      },
      colors: {
        danger: RMR_DANGER,
        indigo: RMR_INDIGO,
      },
    };
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
      this.$emit("input", false);
    },
    onCancel() {
      this.$emit("cancel");
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-confirm-card {
  padding: 24px;
  border-radius: $rmr-radius-2xl !important;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  &__icon-box {
    width: 40px;
    height: 40px;
    border-radius: $rmr-radius-lg;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &--default {
      background: rgba(99, 102, 241, 0.1);
    }

    &--danger {
      background: rgba(220, 38, 38, 0.1);
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $rmr-text-primary;
  }

  &__message {
    font-size: 13px;
    color: $rmr-text-secondary;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}
</style>
